import VideoPodcastSettings from './VideoPodcastSettings';

export default VideoPodcastSettings;
